export const sortFields = [
	'organization.name',
	//
	'customer.name',
	//
	'job.name',
	//
	'name',
	//
	'pagesToCompare',
	//
	'originalFile.filename',
	'variationFile.filename',
	//
	'createdAt',
	'createdBy.name',
	//
	'status.name',
] as const;
